module.exports = __webpack_public_path__ + "4abdc72eb407ef385c5a4b26f5946b4f.pdf";